import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type DeleteResellerAlertDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	pending?: boolean;
};

export function DeleteResellerAlertDialog({
	open,
	onOpenChange,
	onConfirm,
	pending,
}: DeleteResellerAlertDialogProps) {
	const { t } = useTranslation();
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t("resellers.deleteTitle")}</AlertDialogTitle>
					<AlertDialogDescription>
						{t("resellers.deleteDescription")}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t("resellers.cancel")}</AlertDialogCancel>
					<AlertDialogAction onClick={onConfirm} disabled={pending}>
						{t("resellers.delete")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
